import { Input, Divider } from 'antd';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import ProductsTable from './ProductsTable';
import { Title } from '../../components/Layout/components';

import GetCurrenciesQuery from '../../components/Query/Currencies';

export interface IProductsProps extends RouteComponentProps<{
  eshop: string;
}> {
  onCollapse?: any;
}
export default class Products extends React.Component<IProductsProps> {

  state = {
    loading: false,
    status: 'pending',
    searchQuery: '',
  };

  constructor(props: any) {
    super(props);
  }

  public componentDidMount() {
    if (this.props.onCollapse) {
      this.props.onCollapse(false);
    }
  }

  render() {
    return (
      <GetCurrenciesQuery>
        {({ primaryCurrency }) => (
          <div>
            <Title>Products</Title>
            <Divider />
            <Input.Search
              placeholder="Search products by title or EAN ..."
              onSearch={query => this.changeSearchQuery(query)}
              onChange={e => this.changeSearchQuery(e.target.value)}
              enterButton={true}
            />
            <ProductsTable
              domain={this.props.match.params.eshop}
              searchQuery={this.state.searchQuery}
              currency={primaryCurrency}
            />
          </div>)}
      </GetCurrenciesQuery>
    );
  }

  private changeSearchQuery(searchQuery: string) {
    this.setState({ searchQuery });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/index.tsx